import MapboxDraw from "@mapbox/mapbox-gl-draw";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
const classes = MapboxDraw.constants.classes;
classes.CANVAS = "maplibregl-canvas";
classes.CONTROL_BASE = "maplibregl-ctrl";
classes.CONTROL_PREFIX = "maplibregl-ctrl-";
classes.CONTROL_GROUP = "maplibregl-ctrl-group";
classes.ATTRIBUTION = "maplibregl-ctrl-attrib";
export default MapboxDraw;
